module.exports = __webpack_public_path__ + "media/images/mercedes-benz-bbad7452061b374117808306f4fe185e.png";